module.exports = __webpack_public_path__ + "static/media/xy.cd954e47.svg";